/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import qs from 'qs';
import { useSelector, useDispatch } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { useSnackbar } from 'notistack';
import {
  useGridApiRef,
  GridActionsCellItem,
  gridSortedRowIdsSelector,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

import PartnerList from '../../components/partnermng/PartnerList';
import AskDialog from '../../components/common/dialog/AskDialog';
import * as partnerApi from '../../lib/api/partner';
import { listPartners } from '../../modules/partnerModule/partners';

import PartnerSearchContainer from './PartnerSearchContainer';



import BaseCodeSelectbox from '../../components/common/datagrid/BaseCodeSelectbox';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import PartnerUploadModalContainer from './PartnerUploadModalContainer';

const PartnerListContainer = () => {
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  const [removeId, setRemoveId] = useState(null);
  const [searchPartnerTyp, setSearchPartnerTyp] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('partnerNm');
  const [searchWords, setsearchWords] = useState(null);
  const [searchTradeTyp,   setSearchTradeTyp]   = useState(['매출처','매입처','제조사']);      // ← 배열로 관리


  const searchList = (values) => {
    let searchData = {
      [values.searchKeyword]: values.searchWords,
    };
    // if (values.searchTradeTyp !== null && values.searchTradeTyp !== '') {
    //   searchData.tradeTyp = qs.stringify(values.searchTradeTyp, { arrayFormat: 'repeat' });
    // }

    if (values.searchPartnerTyp !== null && values.searchPartnerTyp !== '') {
      searchData.partnerTyp = values.searchPartnerTyp;
    }
    // 배열이 비어 있지 않을 때만 partnerTyp 필터 추가
    // if (Array.isArray(values.searchTradeTyp) && values.searchTradeTyp.length > 0) {
    //   searchData.tradeTypList = values.searchTradeTyp;
    // }

    dispatch(listPartners(searchData));
    setSearchTradeTyp(values.searchTradeTyp);  // ← 이름 통일
    setSearchPartnerTyp(values.searchPartnerTyp);
    setSearchKeyword(values.searchKeyword);
    setsearchWords(values.searchWords);
  };

  const { partners, error, loading } = useSelector(
    ({ partnerModule, loading }) => ({
      partners: partnerModule.partners.partners,
      error: partnerModule.partners.error,
      loading: loading['partner/LIST_PARTNERS'],
    }),
  );

  // 컴포넌트 마운트 후 list 데이터 요청
  useEffect(() => {
    dispatch(listPartners());
  }, []);

  const renderParTypeCell = (params) => {
    params.filterObject = {
      blcCd: 'BASE',
      mlcCd: 'PARTNER',
      slcCd: 'PARTNER_TYP',
      useYn: 'Y',
    };
    params.name = 'partnerTyp';
    return <BaseCodeSelectbox {...params} />;
  };

  const renderCreditCell = (params) => {
    params.filterObject = {
      blcCd: 'BASE',
      mlcCd: 'PARTNER',
      slcCd: 'CREDIT_RATING',
      useYn: 'Y',
    };
    params.name = 'creditRating';
    return <BaseCodeSelectbox {...params} />;
  };

  const apiRef = useGridApiRef();

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleCellFocusOut = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.startRowEditMode({ id });
  };

  const handleSaveClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.commitRowChange(id);
//    apiRef.current.startRowEditMode(id, 'view');
    apiRef.current.stopRowEditMode({ id, ignoreModifications: false });
    const row = apiRef.current.getRow(id);

    //edit api call
    onSave(row);
  };

  const handleDeleteClick = (id) => (event) => {
    event.stopPropagation();

    //remove 작업
    setVisible(true);
    setRemoveId(id);
  };

  const handleCancelClick = (id) => (event) => {
    event.stopPropagation();
//    apiRef.current.startRowEditMode(id, 'view');

    // const row = apiRef.current.getRow(id);
    // if (row.isNew) {
    //   apiRef.current.updateRows([{ id, _action: 'delete' }]);
    // }

    apiRef.current.stopRowEditMode({ id, ignoreModifications: true });

    const row = apiRef.current.getRow(id);
    if (row.isNew) {
      apiRef.current.updateRows([{ id, _action: 'delete' }]);
    }
  };

  const onSave = async (data) => {
    try {
      const response = await partnerApi.editPartner(data);

      if (response.data.result === 'success') {
        apiRef.current.updateRows([{ ...data, isNew: false }]);
        enqueueSnackbar('수정 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      apiRef.current.updateRows([{ id: data.id, _action: 'delete' }]);
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onRemove = async () => {
    try {
      const res = await partnerApi.removePartner(removeId);
      if (res) {
        apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveId(null);
  };

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'partnerUuid',
        headerName: '회사코드',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'partnerTyp',
        headerName: '거래처 종류',
        minWidth: 100,
        flex: 1,
        renderEditCell: renderParTypeCell,
        description: '',
        align: 'center',
        headerAlign: 'center',
        editable: true,
      },
      {
        field: 'partnerNm',
        headerName: '회사명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
        renderCell: (params) => (
          <Link
            underline="none"
            component={RouterLink}
            to={`/partnermng/${params.row.partnerUuid}`}
          >
            {params.value}
          </Link>
        ),
      },
      {
        field: 'regNumber',
        headerName: '사업자번호',
        minWidth: 130,
        flex: 1,
        type: 'string',
        editable: true,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'partnerPhone',
        headerName: '연락처',
        minWidth: 130,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'partnerAddr',
        headerName: '주소',
        minWidth: 250,
        flex: 1,
        type: 'string',
        editable: true,
      },

      // {
      //   field: 'creditRating',
      //   headerName: '신용등급',
      //   minWidth: 100,
      //   flex: 1,
      //   renderEditCell: renderCreditCell,
      //   description: '',
      //   align: 'center',
      //   headerAlign: 'center',
      //   editable: true,
      // },

      // {
      //   field: 'loanAmt',
      //   headerName: '여신한도',
      //   minWidth: 150,
      //   flex: 1,
      //   type: 'number',
      //   valueFormatter: (params) => {
      //     const valueFormatted = Number(params.value).toLocaleString('ko-KR');
      //     return `₩ ${valueFormatted}`;
      //   },
      //   editable: true,
      // },
      {
        field: 'partnerDesc',
        headerName: '비고',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'crtNm',
        headerName: '등록자',
        minWidth: 80,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'crtDt',
        headerName: '등록일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'cngNm',
        headerName: '수정자',
        minWidth: 80,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'cngDt',
        headerName: '수정일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      // {
      //   field: 'actions',
      //   type: 'actions',
      //   headerName: 'Actions',
      //   width: 100,
      //   cellClassName: 'actions',
      //   getActions: ({ id }) => {
      //     const isInEditMode = apiRef.current.getRowMode(id) === 'edit';

      //     if (isInEditMode) {
      //       return [
      //         <GridActionsCellItem
      //           icon={<SaveIcon />}
      //           label="Save"
      //           onClick={handleSaveClick(id)}
      //           color="primary"
      //         />,
      //         <GridActionsCellItem
      //           icon={<CancelIcon />}
      //           label="Cancel"
      //           className="textPrimary"
      //           onClick={handleCancelClick(id)}
      //           color="inherit"
      //         />,
      //       ];
      //     }

      //     return [
      //       <GridActionsCellItem
      //         icon={<EditIcon />}
      //         label="Edit"
      //         className="textPrimary"
      //         onClick={handleEditClick(id)}
      //         color="inherit"
      //       />,
      //       <GridActionsCellItem
      //         icon={<DeleteIcon />}
      //         label="Delete"
      //         onClick={handleDeleteClick(id)}
      //         color="inherit"
      //       />,
      //     ];
      //   },
      // },
    ],
    [apiRef, handleEditClick, handleSaveClick, handleCancelClick],
  );

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  const handleDownExcel = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: getUnfilteredRows,
      fileName: '거래처 리스트',
      utf8WithBom: true,
    });
  };

  const getUnfilteredRows = ({ apiRef }) => gridSortedRowIdsSelector(apiRef);

  const [uploadVisible, setUploadVisible] = useState(false);
  const openUploadModel = () => {
    setUploadVisible(true);
  };
  const closeUploadModal = () => {
    setUploadVisible(false);
  };

  return (
    <>
      <BreadcrumbsContainer
        title="기준정보/거래처 관리/거래처 리스트"
        icon="partner"
      />
      <PartnerSearchContainer
        searchList={searchList}
        searchTradeTyp={searchTradeTyp}
        searchPartnerTyp={searchPartnerTyp}
        searchKeyword={searchKeyword}
        searchWords={searchWords}
        downloadExl={handleDownExcel}
        uploadExl={openUploadModel}
      />
      <PartnerList
        apiRef={apiRef}
        columns={columns}
        partners={partners}
        error={error}
        loading={loading}
        handleRowEditStart={handleRowEditStart}
        handleRowEditStop={handleRowEditStop}
        handleCellFocusOut={handleCellFocusOut}
        
        columnVisibilityModel={{
          id: false,
          partnerUuid: false,
        }}
      />
      <PartnerUploadModalContainer
        title="거래처 엑셀 업로드"
        open={uploadVisible}
        handleClose={closeUploadModal}
      />
      <AskDialog
        visible={visible}
        title="거래처 삭제"
        description="선택한 거래처를 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default PartnerListContainer;
